import { TextField } from "@mui/material";
import React from "react";

interface CustomTextFieldProps extends React.ReactElement {
  required: boolean;
  fieldKey: string;
  onChange: (key: string, value: string) => void;
  value: string;
  helperText?: string;
  multiline?: boolean;
  placeholder?: string;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  required,
  placeholder,
  fieldKey,
  onChange,
  value = "",
  helperText,
  multiline,
}) => {
  return (
    <TextField
      placeholder={placeholder}
      required={required}
      helperText={helperText}
      variant={multiline ? "outlined" : "standard"}
      multiline={multiline}
      value={value}
      onChange={(e) => onChange(fieldKey, e.target.value)}
    />
  );
};

export default CustomTextField;
